/**
 * 用户协议mixin
 */

import { mapGetters, mapActions } from "vuex"
import { checkIfUserAgreed, getAuthManageItemKey, getTempAuthStatus } from "../../business/auth"

export default {
  data() {
    return {
      // 默认同意购买条例
      agreeChecked: false,
      // 当前业务是否已经勾选
      hasPay: false,
      // 展示警告
      hideWarn: true
    }
  },
  computed: {
    ...mapGetters(["loginState", "userPayGroupIds", "sandbox", "pf", "sessionObj", "userAgent", "fromMini"])
  },
  methods: {
    ...mapActions(["getUserPayGroup", "pushUserPayGroup"]),
    checkUserPrivacy(currentItem) {
      if (!checkIfUserAgreed(currentItem.groupId, currentItem.busId, getAuthManageItemKey(currentItem, this.pf))) {
        this.$router.replace({
          path: "/auth",
          query: {
            redirect: this.$route.fullPath,
            bizgroupid: currentItem.groupId,
            bizid: currentItem.busId
          }
        })
        return false
      }
      return true
    },
    /**
     * 检查当前业务是否有已经购买过
     * @param currentItem 当前业务
     */
    checkAgreeChecked(currentItem) {
      return this.getUserPayGroup({
        loginState: this.loginState,
        sessionObj: this.sessionObj,
        sandbox: this.sandbox,
        pf: this.pf
      }).then(() => {
        this.agreeChecked = this.userPayGroupIds.includes(Number(currentItem.groupId))
        this.hasPay = this.userPayGroupIds.includes(Number(currentItem.groupId))
        this.hideWarn = true
      })
    },
    /**
     * 添加当前支付业务
     * @param currentItem 当前业务
     */
    pushUserPayGroupId(currentItem) {
      if (currentItem && currentItem.groupId) {
        this.pushUserPayGroup({
          loginState: this.loginState,
          groupId: Number(currentItem.groupId)
        })
      }
    },
    triggerAgreeChecked(check) {
      this.agreeChecked = check
    },
    triggerHideWarn(bool) {
      this.hideWarn = bool
    },
    // 小程序中要一进入页面就弹窗
    isShowUserAuthPage(currentItem) {
      if (this.userAgent.weixinminiprogram || this.fromMini) {
        const key = getAuthManageItemKey(currentItem, this.pf)
        const keyStr = `${currentItem.groupId}_${currentItem.busId}${key ? `_${key}` : ""}`
        if (!checkIfUserAgreed(currentItem.groupId, currentItem.busId, key) && !getTempAuthStatus(keyStr)) {
          this.$router.replace({
            path: "/auth",
            query: {
              redirect: this.$route.fullPath,
              bizgroupid: currentItem.groupId,
              bizid: currentItem.busId
            }
          })
          return false
        }
        return true
      }
      return true
    }
  }
}
